import {
  IMorPduReadings,
  IMorPduReadingsRackWise,
  IMorTempRhReadings,
  IMorTempRhReadingsRackWise,
  IStandardAPIResponse,
} from '../../vm';
import { httpClient, handleErrorResp } from '../UtilService';

export async function getMorTempAndRhReadings(
  params: any
): Promise<IStandardAPIResponse<Array<IMorTempRhReadings>>> {
  try {
    let res = await httpClient<Array<IMorTempRhReadings>>(
      `datacenters/mor-temp-rh-readings`,
      'GET',
      params
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMorTempAndRhReadingsRackWise(
  params: any
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `datacenters/mor-temp-rh-readings/rackwise`,
      'GET',
      params
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getMorSensorTempAndRhReadings(
  params: any
): Promise<IStandardAPIResponse<Array<any>>> {
  try {
    let res = await httpClient<Array<any>>(
      `temp-rh/sensor/details`,
      'GET',
      params
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getMorPduReadings(
  params: any
): Promise<IStandardAPIResponse<Array<IMorPduReadings>>> {
  try {
    let res = await httpClient<Array<IMorPduReadings>>(
      `datacenters/mor-pdu-readings`,
      'GET',
      params
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getMorPduReadingsRackWise(
  params: any
): Promise<IStandardAPIResponse<Array<IMorPduReadingsRackWise>>> {
  try {
    let res = await httpClient<Array<IMorPduReadingsRackWise>>(
      `datacenters/mor-pdu-readings/rackwise`,
      'GET',
      params
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
